import React from 'react';
import './HexagramInfo.css';
import movingLineMeanings from '../data/movingLineMeanings';

const HexagramInfo = ({ result, phoneNumber, getHexagramStyle, getNumberStyle, getEnergyStyle }) => {

  const getMovingLineMeaning = (hexagramName, lineNumber) => {
    if (!movingLineMeanings[hexagramName] || !movingLineMeanings[hexagramName][lineNumber]) {
      return 'Chưa có dữ liệu';
    }
    return movingLineMeanings[hexagramName][lineNumber];
  };

  return (
    <section id="hexagram-section" className="hexagram-section">
      <h2 className="section-title">☯️ Thông Tin Quẻ Dịch Số {phoneNumber}</h2>
      <div className="hexagram-info-container">
        <div className="results-grid">
          <div className="hexagram-card">
            <div className="energy-number-row">
              <h3 style={getNumberStyle(result.main.name)}>Quẻ Chính</h3>
            </div>
            <div 
              className="energy-name-row" 
              style={{
                ...getEnergyStyle(String(result.main.name)), 
                ...getHexagramStyle(result.main.name)
              }}
            >
              <p className="result-text hexagram-name">{result.main.name}</p>
            </div>
          </div>
          <div className="hexagram-card">
            <div className="energy-number-row">
              <h3 style={getNumberStyle(result.movingLine)}>Hào Động</h3>
              <span style={getNumberStyle(result.movingLine)}>{result.movingLine}</span>
            </div>
            <div className="energy-name-row" style={getEnergyStyle(String(result.movingLine))}>
              <div className="moving-line-meaning">
                {getMovingLineMeaning(result.main.name, result.movingLine)}
              </div>
            </div>
          </div>
          <div className="hexagram-card">
            <div className="energy-number-row">
              <h3 style={getNumberStyle(result.transformed.name)}>Quẻ Biến</h3>
            </div>
            <div 
              className="energy-name-row" 
              style={{...getEnergyStyle(String(result.transformed.name)), ...getHexagramStyle(result.transformed.name)}}
            >
              <p className="result-text hexagram-name">{result.transformed.name}</p>
            </div>
          </div>
        </div>
        <div className="number-pairs">
          <div className="table-container">
            <table className="table-border" style={{ border: '1px solid var(--border-color)', borderRadius: '8px' }}>
              <tbody>
                {result.numberPairs.map((pair, index) => (
                  <tr key={index}>
                    <td>{pair.pair}</td>
                    <td style={{...getHexagramStyle(pair.hexagram)}}>
                      <span className="result-text hexagram-name">{pair.hexagram}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HexagramInfo;
